import { BroadbandLandingScreen } from './BroadbandLandingScreen'
import { BroadbandQuotes } from './BroadbandQuotes'

export const routes = [
  { path: '/broadband', component: BroadbandLandingScreen },
  { path: '/broadband/deals', component: BroadbandQuotes }
]
